import React from 'react';
import { Flex, Text } from 'rebass';
import styled from 'styled-components';
import FullLayout2 from '../../../components/FullLayout';
import Header from '../../asyncIntake/Header';
import { isMobile } from 'react-device-detect';
import { withRouter } from 'react-router-dom';
import { SUBSCRIBE_GUT_RESET_WITH_KITS_URL } from './SubscribeWithKits';
import { SUBSCRIBE_GUT_RESET_NO_KITS_URL } from './SubscribeNoKits';

const SuperContainer = styled(Flex)`
  width: 100vw;
  justify-content: center;
  z-index: 1;
  overflow-y: auto;
  flex: 1;
`;

const Container = styled(Flex)`
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  margin-top: 80px;
  z-index: 1;
  position: relative;
  overflow-y: none;
  margin-bottom: 36px;
  flex-direction: column;
`;

const ButtonWith = ({ text, onClick }) => {
  return (
    <Flex
      mb={3}
      style={{
        borderRadius: '10px',
        border: '1px solid #D0D2D5',
        cursor: 'pointer',
        padding: '12px 18px 12px 22px',
        gap: '12px',
        alignItems: 'center',
      }}
      onClick={onClick}
    >
      <Flex flex={1} flexDirection={'column'}>
        <Text style={{ fontSize: '14px', fontWeight: 400 }}>{text}</Text>
      </Flex>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none">
        <path
          d="M0.365983 0.365983C0.131644 0.600393 0 0.918278 0 1.24973C0 1.58119 0.131644 1.89907 0.365983 2.13348L6.55348 8.32098L0.365983 14.5085C0.138286 14.7442 0.0122922 15.06 0.0151402 15.3877C0.0179882 15.7155 0.14945 16.029 0.38121 16.2608C0.61297 16.4925 0.926485 16.624 1.25423 16.6268C1.58198 16.6297 1.89773 16.5037 2.13348 16.276L9.20473 9.20473C9.43907 8.97032 9.57072 8.65244 9.57072 8.32098C9.57072 7.98953 9.43907 7.67164 9.20473 7.43723L2.13348 0.365983C1.89907 0.131644 1.58119 0 1.24973 0C0.918278 0 0.600393 0.131644 0.365983 0.365983Z"
          fill="#344F7A"
        />
      </svg>
    </Flex>
  );
};

export const SubscribeKitSelection = withRouter(({ onContinue, history }) => {
  return (
    <FullLayout2 pb={5} style={{ zIndex: 11, overflowY: isMobile ? 'hidden' : 'auto', overflowX: 'hidden', maxHeight: '100vh' }}>
      <Header dark={false} mb={3} />
      <SuperContainer>
        <Container>
          <Text style={{ fontWeight: 500, fontSize: '18px' }} mb={4}>
            Do you already have GI test results, or would you prefer to get a new GI test kit?
          </Text>

          <ButtonWith
            onClick={() => {
              history.push(SUBSCRIBE_GUT_RESET_NO_KITS_URL)
            }}
            text={'I have recent GI test results'}
          />
          <ButtonWith
            onClick={() => {
              history.push(SUBSCRIBE_GUT_RESET_WITH_KITS_URL)
            }}
            text={'I’d like to order a new GI test'}
          />
          <Text style={{ fontWeight: 400, fontSize: '13px', opacity: 0.88 }} mt={2}>
            If you’ve completed a GI-MAP, Genova, or similar gut health test in the past 12 months, you can upload those results. If your test is older—or if you’d prefer updated insights—you can
            request a new GI test kit.
          </Text>
        </Container>
      </SuperContainer>
    </FullLayout2>
  );
});
